import {defineStore} from 'pinia';
import {BaseDictionaryStore} from '../baseDictionaryStore';
import {ModuleBudgetGroupItem} from '../moduleConst';
import budgetGroupItemAPI from '@/apis/di/budgetGroupItemAPI';
const budgetGroupItemStore = new BaseDictionaryStore(budgetGroupItemAPI);

export const useBudgetGroupItemStore = defineStore(ModuleBudgetGroupItem, {
  state: () => ({
    ...budgetGroupItemStore.state,
    _config: {
      key: 'budget_expense_group_item_id',
      name: 'budget_expense_group_item_name',
      code: 'budget_expense_group_item_code',
      table: 'di_budget_expense_group_item',
      moduleName: 'Nhóm mục chi',
      defaultSort: 'budget_expense_group_item_code',
    },
    moduleName: 'budgetGroupItem',
  }),
  actions: {
    ...budgetGroupItemStore.action,
  },
  getters: {
    ...budgetGroupItemStore.getters,
  },
});
